var path = 'src/app/components/common/refresh-button/refresh-button.template.html';
var html = "<button class=\"btn btn-primary\" ng-click=\"$ctrl.onRefresh()\">\n  Refresh ({{$ctrl.refreshedAgo}})\n</button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;